/**
 * @fileoverview PUT handler for the "/apps/business/accounts" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsLegacyCatalogAccountsCacheKeys } from "./constants";
import type { PutLegacyCatalogAccountsProps, LegacyCatalogAccountsResult } from "./types";

export const putLegacyCatalogAccounts = reactQueryMutationAdapter(
  appsLegacyCatalogAccountsCacheKeys,
  (props: PutLegacyCatalogAccountsProps): Promise<LegacyCatalogAccountsResult> => {
    return fetch("/apps/business/accounts", "PUT", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
